module.exports = __webpack_public_path__ + "static/media/9DESA32.455d2c23.jpg";